import React from 'react';
import ButtonIconBase from './ButtonIconBase';
import classNames from 'classnames';

function ButtonIconPrimary(props) {
    let buttonClasses = classNames('btn-primary', props.className);

    return <ButtonIconBase {...props} className={buttonClasses} />;
}

ButtonIconPrimary.propTypes = {
    ...ButtonIconBase.propTypes
};

ButtonIconPrimary.defaultProps = {
    ...ButtonIconBase.defaultProps
};

export default ButtonIconPrimary;
